// src/components/AddUserModal.js
import React, { useEffect, useState } from "react";
import { appPrimaryColor } from "../../utils/constants";
import { toast } from "react-toastify";
import { inviteOrg, inviteUser } from "../../api";
import { IoMdClose } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { getUser } from "../../utils";

const AddUserModal = ({ isOpen, onRequestClose, admin = false }) => {
  const [userDetails, setUserDetails] = useState({
    email: "",
  });
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    setDisableButton(false);
  }, [isOpen]);

  const user = getUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableButton(true);

    let inviteApi = null

    if (user?.role === 'super_admin') {
      inviteApi = inviteOrg;
    } else {
      inviteApi = inviteUser;
    }

    try {
      const response = await inviteApi(userDetails);
      if (response.status === 201) {
        toast.success("Invitation sent successfully.");
        onRequestClose();
        setUserDetails({ email: "" });
      } else if (response.status === 200) {
        toast.error("The email id already exists.");
      } else {
        toast.error("Failed send invitation. Please try again later.");
      }
    } catch (error) {
      console.error("Error in sending invitation:", error);
      toast.error("Failed to send invitation. Please try again later.");
    } finally {
      setDisableButton(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />

      {/* Modal Container */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left shadow-xl transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={() => {
              onRequestClose();
              setUserDetails({ email: "" });
            }}
            className="absolute right-4 top-4 rounded-full p-1 hover:bg-gray-100 transition-colors"
          >
            <IoMdClose size={20} className="text-gray-500" />
          </button>

          {/* Modal Header */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Invite New {admin ? "Organization" : "Farmer"}</h2>
            <p className="mt-1 text-sm text-gray-500">
              Send an invitation to add a new {admin ? "organization" : "farmer"} to your network
            </p>
          </div>

          {/* Modal Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Email Address
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MdEmail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="email"
                  id="email"
                  value={userDetails.email}
                  onChange={(e) => setUserDetails({ email: e.target.value })}
                  className="block w-full pl-10 pr-4 py-2.5 text-gray-900 rounded-lg border border-gray-300 
                                             focus:ring-2 focus:ring-darkGreen focus:border-transparent
                                             placeholder:text-gray-400"
                  placeholder={admin ? "organization@example.com" : "farmer@example.com"}
                  required
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end pt-4">
              <button
                type="button"
                onClick={() => {
                  onRequestClose();
                  setUserDetails({ email: "" });
                }}
                className="w-full sm:w-auto px-4 py-2.5 rounded-lg border border-gray-300
                                         text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 
                                         focus:ring-offset-2 focus:ring-gray-500 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={disableButton}
                className={`w-full sm:w-auto px-6 py-2.5 rounded-lg text-white 
                                          ${disableButton
                    ? 'bg-gray-400 cursor-not-allowed'
                    : `${appPrimaryColor} hover:opacity-90 focus:outline-none focus:ring-2 
                                                 focus:ring-offset-2 focus:ring-darkGreen`
                  } transition-colors`}
              >
                {disableButton ? 'Sending...' : 'Send Invitation'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
